import * as React from "react";
import moment from "moment";
import { color } from "../../../constant/color";
import { Link } from "react-router-dom";
import DataTable, { TableColumn } from "react-data-table-component";
import "./style.css";
import { tableCustomStyles } from "../../../HelperFunctions";

const CompnaiesTable = ({ data }) => {
  const formatSecretKey = (item) =>
    `${item.substring(0, 5)}....${item.substring(
      item.length - 5,
      item.length
    )}`;

  const columns = [
    {
      name: "#",
      selector: (row, index) => index + 1,
      width: "50px",
    },
    {
      name: "Name",
      selector: (row) => `${row.companyname.substring(0, 25)}...`,
      sortable: true,
      center: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      center: true,
    },
    {
      name: "Phone number",
      selector: (row) => row.phone,
      sortable: true,
    },
    {
      name: "Date created",
      selector: (row) => moment(row.datecreated).format("lll"),
      sortable: true,
      center: true,
    },
    {
      name: "Status",
      cell: (row) => (
        <div
          className="status-btn p-1 rounded"
          style={{
            background:
              row.activestatus === "inactive" ? "#ffa58733" : "#6fed6f33",
            color: row.activestatus === "inactive" ? color.red : color.green,
          }}
        >
          {row.activestatus}
        </div>
      ),
      sortable: true,
      center: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <Link
          to={`/company/${row.companyalias}`}
          className="text-decoration-underline"
        >
          View
        </Link>
      ),
      button: true,
      center: true,
    },
  ];

  return (
    <div className="table-responsive">
      <DataTable
        columns={columns}
        customStyles={tableCustomStyles}
        data={data}
        pagination
      />
    </div>
  );
};

export default CompnaiesTable;
